"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeWhiteSpaces = void 0;
const removeWhiteSpaces = input => {
  return input.replace(/\s/g, '');
};
exports.removeWhiteSpaces = removeWhiteSpaces;
